export const JOB_EDIT_SUBMIT_REQUEST = 'job/edit-submit-request'
export const JOB_EDIT_SUBMIT_SUCCESS = 'job/edit-submit-success'
export const JOB_EDIT_SUBMIT_FAILED = 'job/edit-submit-failed'
